<h1 mat-dialog-title>Product Plan Levels for {{data.companyName}}</h1>
<div mat-dialog-content>
  <div class="setting-mode-panel">
    <div class="setting-mode-buttons">
      @if (canInherit()) {
        <button
          mat-stroked-button
          type="button"
          [class.active-mode]="mode === 'inherit'"
          (click)="setMode('inherit')">
          Use Parent Setting
        </button>
      }
      <button
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'none'"
        (click)="setMode('none')">
        No Plan Restrictions For This Company
      </button>
      <button
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'custom'"
        (click)="setMode('custom')">
        Set Custom Plan Levels
      </button>
    </div>
    @if (mode === 'inherit' && canInherit()) {
      <p class="setting-mode-help">
        This company will use Product Plan Levels from {{data.parentCompanyName || 'its parent company'}}.
      </p>
    }
    @if (mode === 'none') {
      <p class="setting-mode-help">
        This company will explicitly override the parent setting and allow all plan levels for its available products.
      </p>
    }
    @if (mode === 'custom') {
      <p class="setting-mode-help">
        Select which plan levels should remain available for this company.
      </p>
    }
  </div>

  @if (validationMessage) {
    <app-inlinemessage
      level="warning"
      [message]="validationMessage">
    </app-inlinemessage>
  }

  @if (products.length === 0) {
    <app-inlinemessage
      level="warning"
      message="No configurable plan levels were found for this company's available products.">
    </app-inlinemessage>
  }

  @if (products.length > 0) {
    <div class="product-plan-list">
      @for (product of products; track trackProduct($index, product)) {
        <div class="benefit-product-card">
          <div class="benefit-product-card-header">
            <mat-checkbox
              class="benefit-product-checkbox"
              [checked]="isBenefitProductSelected(product.id)"
              [indeterminate]="isBenefitProductIndeterminate(product.id)"
              [disabled]="!isCustomMode()"
              (click)="$event.stopPropagation()"
              (change)="onBenefitProductToggle(product.id, $event.checked)">
            </mat-checkbox>
            <div class="benefit-product-logo-wrap">
              @if (product.imageUrl) {
                <img
                  class="benefit-product-logo"
                  [src]="product.imageUrl"
                  [alt]="getProductLabel(product) + ' logo'"
                  loading="eager"
                  decoding="async"
                  referrerpolicy="no-referrer"
                  (error)="product.imageUrl = ''"
                  />
              }
              @if (!product.imageUrl) {
                <div class="benefit-product-logo-placeholder">
                  {{ getProductLabel(product).charAt(0) }}
                </div>
              }
            </div>
            <div class="benefit-product-main">
              <div class="benefit-product-name">{{ getProductLabel(product) }}</div>
              <div class="benefit-product-description">
                {{ product.description || product.productName }}
              </div>
            </div>
            <button
              type="button"
              class="benefit-product-expand-btn"
              (click)="toggleBenefitProductExpansion(product.id)">
              <span>{{ getSelectedBenefitPlanCount(product.id) }}/{{ product.plans.length }} plans</span>
              <mat-icon>{{ isBenefitProductExpanded(product.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
          @if (isBenefitProductExpanded(product.id)) {
            <div
              class="benefit-product-plans">
              @for (plan of product.plans; track trackPlan($index, plan)) {
                <div
                  class="benefit-product-plan"
                  (click)="onBenefitPlanToggle(product.id, plan.id, !isBenefitPlanSelected(product.id, plan.id))">
                  <mat-checkbox
                    class="benefit-product-plan-checkbox"
                    [checked]="isBenefitPlanSelected(product.id, plan.id)"
                    [indeterminate]="isBenefitPlanIndeterminate(product.id, plan.id)"
                    [disabled]="!isCustomMode()"
                    (click)="$event.stopPropagation()"
                    (change)="onBenefitPlanToggle(product.id, plan.id, $event.checked)">
                  </mat-checkbox>
                  <div class="benefit-product-plan-copy">
                    <div class="benefit-product-plan-name">{{ plan.name }}</div>
                    @if (plan.description) {
                      <div class="benefit-product-plan-description">
                        {{ plan.description }}
                      </div>
                    }
                  </div>
                  @if (plan.detailsUrl) {
                    <button
                      type="button"
                      class="benefit-product-plan-link"
                      (click)="openBenefitPlanDetails(plan.detailsUrl, $event)">
                      more details
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button class="donebutton" color="primary" (click)="okClicked()">Done</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
